import { Component, OnInit } from '@angular/core';
import { PartnerInput } from '../../../models/partner-input.model';
import { PreviewDocumentTypes } from '../../../models/update-customer-ack-document.model';
import { OsmosisService } from '../../services/osmosis.service';
import { SharedEngagementTableComponent } from '../../shared/engagement-table/engagement-table.component';

@Component({
  selector: 'app-finding-doc-review-list',
  templateUrl: './finding-doc-review-list.component.html',
  styleUrls: ['./finding-doc-review-list.component.scss'],
  standalone: true,
  imports: [SharedEngagementTableComponent]
})
export class FindingDocReviewListComponent implements OnInit {
  engagementList!: PartnerInput[];
  isPoeDoc = true;
  prevDocumentType!: string;
  loading!: boolean;

  constructor(private osm: OsmosisService) {}

  ngOnInit() {
    this.initializePoeDocReviewList();
    this.prevDocumentType = PreviewDocumentTypes.poedocument;
  }

  initializePoeDocReviewList() {
    this.loading = true;
    this.osm.getEngagementsForPoeDocReview().subscribe(serviceOutput => {
      this.engagementList = serviceOutput;
      this.loading = false;
    });
  }
}
